// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar-module_avatar__13U8c","size24":"Avatar-module_size24__BQ23V","colorDefault":"Avatar-module_colorDefault__7WjOn","img":"Avatar-module_img__A6Fkc"};